
export const plateStockMap = [
  {
    name: '发行价',
    field: 'issue_price',
    unit: 'issue',
    value: '',
    hasPreValue: true,
  },
  {
    name: '发行市盈率(静)',
    field: 'issue_pe_static',
    unit: 'ttm',
    value: '',
    hasPreValue: true,
  },
  {
    name: '申购上限',
    field: 'order_limit_up',
    unit: '万股',
    value: '',
  },
  {
    name: '行业市盈率',
    field: 'industry_ttm',
    unit: 'ttm',
    value: '',
  },
  {
    name: '发行总数',
    field: 'issue_count',
    unit: '万股',
    value: '',
  },
  {
    name: '所属行业',
    field: 'industry_name',
    unit: '',
    value: '',
  },
]

export const plateStockWillMap = [
  {
    name: '上市日',
    field: 'listing_date',
    unit: 'date',
    value: '',
  },{
    name: '发行价',
    field: 'issue_price',
    unit: 'issue',
    value: '',
  },{
    name: '配售比例',
    field: 'placing_ratio',
    unit: 'winning',
    value: '',
  },
]

export const plateStockListedMap = [
  {
    name: '上市日',
    field: 'listing_date',
    unit: 'date',
    value: '',
  },
  {
    name: '发行价',
    field: 'issue_price',
    unit: 'issue',
    value: '',
  },
  {
    name: '每百股最高获利',
    field: 'max_profit',
    unit: '元',
    value: '',
  },
  {
    name: '首日最高涨幅',
    field: 'max_change',
    unit: '%',
    value: '',
  },
  {
    name: '首日开盘涨幅',
    field: 'first_opening_change',
    unit: '%',
    value: '',
  },
  {
    name: '首日收盘涨幅',
    field: 'first_closing_change',
    unit: '%',
    value: '',
  },
]